// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"Checkbox_checkboxLabel__BX_sg"};